"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.object.values");
var _constants = require("@/utils/constants");
var _time = require("@/utils/time");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  name: 'DatePicker',
  props: {
    type: {
      type: String,
      default: 'date'
    },
    defaultValue: {
      type: Object,
      default: function _default() {
        return _constants.DEFAULT_DATE_REGION;
      }
    }
  },
  data: function data() {
    return {
      PICKER_OPTIONS: this.type === 'daterange' ? _constants.PICKER_OPTIONS : {},
      value: this.type === 'daterange' ? Object.values(this.defaultValue) : Object.values(this.defaultValue)[1]
    };
  },
  methods: {
    onChange: function onChange(val) {
      var date = null;
      if (this.type === 'daterange') {
        date = {
          'start_date': val[0],
          'end_date': val[1]
        };
      } else {
        date = {
          'start_date': val,
          'end_date': val
        };
      }
      if ((0, _time.isMaxDate)(date['end_date'])) return this.$message('日期范围错误，请重新选择!');
      this.$emit('change', date);
    }
  }
};
exports.default = _default2;